"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Cell", {
  enumerable: true,
  get: function get() {
    return _cell["default"];
  }
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _row["default"];
  }
});
exports.Table = void 0;
Object.defineProperty(exports, "Tbody", {
  enumerable: true,
  get: function get() {
    return _tbody["default"];
  }
});
Object.defineProperty(exports, "Tfoot", {
  enumerable: true,
  get: function get() {
    return _tfoot["default"];
  }
});
Object.defineProperty(exports, "Thead", {
  enumerable: true,
  get: function get() {
    return _thead["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _pagination = require("../pagination");
var _tab = require("../tabs/tab");
var _sortResults = _interopRequireDefault(require("./actions/sortResults"));
var _filterResults = _interopRequireDefault(require("./actions/filterResults"));
var _scrollbar = require("../scrollbar");
var _tbody = _interopRequireDefault(require("./tbody"));
var _thead = _interopRequireDefault(require("./thead"));
var _tfoot = _interopRequireDefault(require("./tfoot"));
var _row = _interopRequireDefault(require("./row"));
var _cell = _interopRequireDefault(require("./cell"));
var _tableModule = _interopRequireDefault(require("./table.module.scss"));
var _excluded = ["children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Table = exports.Table = /*#__PURE__*/function (_Component) {
  function Table() {
    var _this;
    _classCallCheck(this, Table);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Table, [].concat(args));
    _defineProperty(_this, "state", {
      page: 1,
      activeSort: {
        column: null,
        direction: null
      },
      data: _this.props.data,
      originalData: _this.props.data,
      searchColumns: []
    });
    _defineProperty(_this, "sortResults", new _sortResults["default"]());
    _defineProperty(_this, "filterResults", new _filterResults["default"]());
    _defineProperty(_this, "selectPage", function (page) {
      if (page !== _this.state.page) {
        _this.setState({
          page: page
        });
      }
    });
    _defineProperty(_this, "sort", function (direction, key) {
      _this.sortResults.setResults(_this.state.data).setSortKey(key).setDirection(direction).sort();
      _this.setState({
        activeSort: {
          column: key,
          direction: direction
        },
        data: _this.sortResults.results
      });
    });
    return _this;
  }
  _inherits(Table, _Component);
  return _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.childrenToData();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.children !== prevProps.children) {
        //reset children data if children change
        this.childrenToData();
      }
      if (this.props.searchTerm !== prevProps.searchTerm) {
        this.filter();
      }
    }
  }, {
    key: "getProps",
    value: function getProps(row) {
      if (row.type === _tbody["default"]) {
        return _objectSpread(_objectSpread({}, row.props), {}, {
          data: this.state.data
        });
      } else {
        return row.props;
      }
    }
  }, {
    key: "filter",
    value: function filter() {
      this.filterResults.setResults(this.state.originalData).setSearchType("subString").setSearchableColumns(this.state.searchColumns).setSearchTerm(this.props.searchTerm).filter();
      this.setState({
        data: this.filterResults.results
      });
    }
  }, {
    key: "childrenToData",
    value: function childrenToData() {
      var data = [];
      var searchColumns = [];
      _react.Children.forEach(this.props.children, function (t) {
        if (t.type === _tbody["default"]) {
          _react.Children.forEach(t.props.children, function (row) {
            var newRow = {};
            _react.Children.forEach(row.props.children, function (cell, key) {
              var _cell$props = cell.props,
                children = _cell$props.children,
                otherProps = _objectWithoutProperties(_cell$props, _excluded);
              newRow[key] = {
                props: otherProps,
                value: children
              };
            });
            data.push(newRow);
          });
        } else if (t.type === _thead["default"]) {
          _react.Children.forEach(t.props.children, function (row) {
            _react.Children.forEach(row.props.children, function (cell, key) {
              /* istanbul ignore if */
              if (cell.props.searchable) {
                searchColumns.push(key);
              }
            });
          });
        }
      });
      this.setState({
        data: data,
        originalData: data,
        searchColumns: searchColumns
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_scrollbar.ShadowScrollbars, {
        autoHeight: true,
        trackBackground: true,
        trackPadding: 15
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _tableModule["default"].table,
        style: this.props.style,
        "data-testid": "table"
      }, _react.Children.map(this.props.children, function (row) {
        return _objectSpread(_objectSpread({}, row), {}, {
          props: _objectSpread({
            page: _this2.state.page,
            rowsPerPage: _this2.props.rowsPerPage,
            sort: _this2.sort,
            activeSort: _this2.state.activeSort
          }, _this2.getProps(row))
        });
      }))), /*#__PURE__*/_react["default"].createElement(_tab.Fixed, null, /*#__PURE__*/_react["default"].createElement(_pagination.Pagination, {
        hide: true,
        page: this.state.page,
        records: this.props.rows,
        recordsPerPage: this.props.rowsPerPage,
        onSelectPage: this.selectPage,
        maxVisiblePages: 10
      })));
    }
  }]);
}(_react.Component);
Table.propTypes = {
  rows: _propTypes["default"].number,
  rowsPerPage: _propTypes["default"].number,
  searchTerm: _propTypes["default"].string
};
Table.defaultProps = {
  rows: 0,
  rowsPerPage: 10,
  searchTerm: null
};
var _default = exports["default"] = Table;